const getFileNameFromURL = (
	url: string,
	withoutDate: boolean = false
): string => {
	if (!url.includes('/')) {
		// throw new Error("URL must contain a '/'");
		return 'File URL Missing'
	}
	const filename = new URL(url).pathname.split('/').pop() || ''
	if (withoutDate) {
		return filename.replace(/^\d{10,}-/i, '')
	}
	return filename
}

export default getFileNameFromURL
